import { LOCALES } from '@/shared/models/constants.models';
import type { IGlobalStore } from './globalStore.model';

export const getDefaultState = (): IGlobalStore => ({
  rootLoading: false,
  submitLoading: false,
  localeLanguages: Object.values(LOCALES),
  locale: LOCALES.en_US, // default
  deviceDNA: '',
  features: [],
  alerts: [],
  tasks: [],
  initialized: false,
  agents: [],
  notifications: [],
  spanishBanner: false,
  alertsAndNotifications: [],
  showVerifyPhoneWrapper: false,
  verifyPhonePageToLand: '',
  showGoPaperlessWrapper: false,
  goPaperlessType: '',
  documents: {},
  showNavigationConfirmation: false,
  navigationPathOnUserConfirmation: '',
  navigationDialogBody: '',
  meta: {
    isMaintenanceMode: false,
    recommendedAppVersion: undefined,
  },
  userSessionMeta: {
    sessionId: '',
    appVersion: '',
    deviceInfo: {
      deviceId: '',
      deviceModel: '',
      deviceOsVersion: '',
      devicePlatform: '',
    },
  },
  base64String: '',
});

const state = getDefaultState();

export default state;
/* {
  rootLoading: false,
  submitLoading: false,
  locale: LOCALES.en_US, // default
  deviceDNA: '',
  features: [],
  alerts: [],
  tasks: [],
  initialized: false,
  agents: [],
  notifications: [],
  spanishBanner: false,
  alertsAndNotifications: [],
  showVerifyPhoneWrapper: false,
  verifyPhonePageToLand: '',
  showGoPaperlessWrapper: false,
  documents: {},
  showNavigationConfirmation: false,
  navigationPathOnUserConfirmation: '',
  navigationDialogBody: '',
  meta: {
    isMaintenanceMode: false,
    recommendedAppVersion: {},
  },
  userSessionMeta: {
    sessionId: '',
    appVersion: '',
    deviceInfo: {
      deviceId: '',
      deviceModel: '',
      deviceOsVersion: '',
      devicePlatform: '',
    },
  },
}; */
